import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useHighlightSlideOpenedState = ({
  rowIndex,
}: {
  rowIndex: number;
}) => {
  return useOpenedStateManager(`highlight-slider-zoom-${rowIndex}`);
};
